/**
 * 小程序配置文件
 */
var calculatorUrl = "";
let appDomain = "";
var apiHost = "";
let wxstate = "";
let env = process.env.NODE_ENV || "";
let currentHostName = window.location.host;
// 一级域名 rongketech.com或者htangcloud.com
let topDomainName = currentHostName
  .split(".")
  .slice(-2)
  .join(".");

if (env == "production") {
  apiHost = ""; // apiHost 会根据路由地址的域名自动匹配
  // apiHost = "https://taskh5.yaorukj.cn";
  wxstate =
    "qrcodeh5case2" +
    (currentHostName.indexOf("htangcloud") != -1 ? "cloud" : "");
  appDomain = `https://${currentHostName}`;
  calculatorUrl = "";
} else if (env == "test") {
  apiHost = "";
  // apiHost = "https://taskh5test.yaorukj.cn";
  wxstate =
    "qrcodeh5case2test" +
    (currentHostName.indexOf("htangcloud") != -1 ? "cloud" : "");
  appDomain = `https://${currentHostName}`;
  calculatorUrl = "";
} else {
  // 开发环境
  apiHost = "https://testapp.rongketech.com";
  // apiHost = "https://taskh5test.yaorukj.cn";
  wxstate = "qrcodeh5case2testcloud";
  appDomain = "https://taskh5test.yaorukj.cn";
  // appDomain = `http://${currentHostName}`;
  topDomainName = "htangcloud.com";
  calculatorUrl = "";
}
// console.log("calculatorUrl:", calculatorUrl);
console.log(
  `--env[${env}]--, apiHost[${apiHost}], wxstate[${wxstate}], appDomain[${appDomain}], currentHostName[${currentHostName}], topDomainName[${topDomainName}]--`
);
var config = {
  // 下面的地址配合云端 Server 工作
  // host,
  apiHost,
  wxstate: wxstate,
  appDomain: appDomain,
  topDomainName: topDomainName,
  calculatorUrl: calculatorUrl,
  operationPlatform: "01", // wxJS接口安全域名:01 耀如(耀如公众号), 00 薪必果(融科公众号)
  // 计算器
  salaryCalculator: `/merchant/calc`,
  // 身份证正面
  idCardOcr: `${apiHost}/bpo-web/upload/idCardOcr`,
  idCardOcrBase64: `${apiHost}/bpo-web/upload/idCardOcrBase64`,
  idCardUrl: `${apiHost}/bpo-web/ocrByTaskNo/idCardUrl`,
  // 图片上传
  uploadOss: `${apiHost}/bpo-web/upload/uploadOss`,
  // 短信验证码
  sendLoginSMS: `${apiHost}/bpo-web/uc/user/sendLoginSMS`,
  // 语音验证码
  sendInvoiceTts: `${apiHost}/bpo-web/uc/user/v2/sendInvoiceTts`,
  // 登录
  appLoginSMS: `${apiHost}/bpo-web/uc/user/appLoginSMS`,
  // 银行卡照片
  bankcard: `${apiHost}/bpo-web/upload/bankcard`,
  // 银行卡发送验证码
  bindCardSendSms: `${apiHost}/bpo-web/uc/userAccount/bindCardSendSms`,
  // 保留个人信息
  saveAuthInfo: `${apiHost}/bpo-web/uc/userAccount/saveAuthInfo`,
  // 我的信息
  signInfo: `${apiHost}/bpo-web/query/userSign/signInfo`,
  // H5扫码接单验证
  scanApplyH5Valid: `${apiHost}/bpo-web/platform/task/scanApplyH5Valid`,
  // 任务详情
  platformDetail: `${apiHost}/bpo-web/platform/task/platformDetail`,
  // 接单
  scanApplyH5: `${apiHost}/bpo-web/platform/task/scanApplyH5`,
  // 登录用户信息
  appLoginInfo: `${apiHost}/bpo-web/uc/user/appLoginInfo`,
  // 同意协议
  frame: `${apiHost}/bpo-web/uc/userSign/sign/frame`,
  // 是否同意框架协议
  isAgreeFrame: `${apiHost}/bpo-web/uc/userSign/sign/isAgreeFrame`,
  // 个人要素认证-H5独立版
  userPersonalAuthH5: `${apiHost}/bpo-web/uc/user/userPersonalAuthH5`,
  userPersonalAuthH5V2: `${apiHost}/bpo-web/uc/user/userPersonalAuthH5V2`,
  // 自然人免登接单 提交身份证信息前校验业务是否已暂停维护
  maintainQuery: `${apiHost}/bpo-web/natural/offline/maintainQuery`,

  smsSignLogin: `${apiHost}/bpo-web/uc/user/smsSignLogin`,
  // 个人要素认证-人脸比对
  userFacePhotoAuth: `${apiHost}/bpo-web/uc/user/userFacePhotoAuth`,
  // H5版本2-扫码接单
  scanApplyH5Case2: `${apiHost}/bpo-web/platform/task/scanApplyH5Case2`,
  scanApplyH5Case2V2: `${apiHost}/bpo-web/platform/task/scanApplyH5Case2V2`,
  smsTaskInfo: `${apiHost}/bpo-web/platform/task/smsTaskInfo`,
  h5ParamsValid: `${apiHost}/bpo-web/platform/task/h5ParamsValid`,
  addAgreementConfirm: `${apiHost}/bpo-web/platform/task/addAgreementConfirm`,
  // 用户登录历史信息
  loginRecord: `${apiHost}/bpo-web/uc/user/loginRecord`,
  // 获取openid
  wxuseropenid: `${apiHost}/bpo-web/wx/code2OpenId`,

  // region 刮刮卡
  // 参数校验
  gomeParamsValid: `${apiHost}/bpo-web/customized/gome/paramsValid`,
  // 国美签约接口
  gomeSign: `${apiHost}/bpo-web/customized/gome/handSign`,
  // 国美跳转查询
  gomeRedirect: `${apiHost}/bpo-web/customized/gome/redirectUrl`,
  // endregion

  // region 国美推手
  // 参数校验
  gomeShareParamsValid: `${apiHost}/bpo-web/customized/gome/share/paramsValid`,
  // 签约
  gomeShareSign: `${apiHost}/bpo-web/customized/gome/share/sign`,
  // 跳转查询
  gomeShareRedirect: `${apiHost}/bpo-web/customized/gome/share/redirectUrl`,
  // 检查小程序版本
  gomeShareCheckMPVersion: `${apiHost}/bpo-web/customized/gome/share/checkMPVersion`,
  // endregion

  // region 委托授权书接口
  // 短信验证码
  authorizeLetterSms: `${apiHost}/bpo-web/uc/userAuthorizeLetter/sendLoginSMS`,
  // 登录
  authorizeLetterSmsLogin: `${apiHost}/bpo-web/uc/userAuthorizeLetter/appLoginSMS`,
  // 保存
  authorizeLetterSave: `${apiHost}/bpo-web/uc/userAuthorizeLetter/saveLetter`,
  // endregion

  wxJsapi: `${apiHost}/bpo-web/wx/jsapiConfig`,

  // 广告 banner
  banners: `${apiHost}/bpo-web/jsh/getBanner`,

  // 加载自定义协议
  agreementQuery: `${apiHost}/bpo-web/platform/task/agreement/query`,
  // 同意自定义协议
  agreementAgree: `${apiHost}/bpo-web/platform/task/agreement/agree`,
  // 检查自定义协议是否已签约过
  userAgreeListV2: `${apiHost}/bpo-web/uc/userSign/sign/userAgreeListV2`,
  // 是否展示框架协议
  defaultAgreementShowFlag: `${apiHost}/bpo-web/platform/task/agreement/defaultAgreementShowFlag`,

  // 我的签约
  myContract: `${apiHost}/bpo-web/uc/wx/ma/query/sign/contract`,
  // 图片展示
  getPhoto: `${apiHost}/bpo-web/banner/getBanner/2`,

  // 我的收入详情
  incomeDetail: `${apiHost}/bpo-web/trade/tradeOrderItemDetail`,
  // 我的收入--列表页面
  tradeOrderItemPage: `${apiHost}/bpo-web/trade/tradeOrderItemPage`,

  // 获取签约规则，获取是否传身份证图片规则
  getTaskRule: `${apiHost}/bpo-web/platform/task/getTaskRule`,

  // 查询企业实名绑定状态
  queryLiveAuthStatus: `${apiHost}/bpo-web/natural/task/queryLiveAuthStatus`,

  // 图形验证码
  captcha: `${apiHost}/bpo-web/uc/user/captcha`,
  // 校验任务是否有效
  authPageValid: `${apiHost}/bpo-web/platform/task/authPageValid`,

  // H5自然人身份证信息更新页
  naturalIdCardInfoUpdateAndPush: `${apiHost}/bpo-web/uc/user/naturalIdCardInfoUpdateAndPush`,

  // 自然人线下导入 登录
  offlineLogin: `${apiHost}/bpo-web/uc/user/naturalOfflineLoginSMS`,
  // 自然人线下导入任务详情页 下一步
  naturalOfflineUserNext: `${apiHost}/bpo-web/uc/user/naturalOfflineUserNext`,
  // 自然人线下导入用户userid直接登录接口
  naturalOfflineUserIdLogin: `${apiHost}/bpo-web/uc/user/naturalOfflineUserIdLogin`,

  // 自然人查询个人是否承担税金或服务费
  naturalRate: `${apiHost}/bpo-web/platform/task/naturalRateFlag`,

  // 获取拉卡拉支付链接
  getLakalaPayUrl: `${apiHost}/bpo-web/natural/pay/`,

  /*  税金支付相关页面接口  */
  // 判断在此商户下，当前信息是否存在订单
  taxCheckExist: `${apiHost}/bpo-web/natural/h5/checkExist`,
  // // 查询此商户下当前信息下订单列表
  // taxOrderList: `${apiHost}/bpo-web/natural/h5/query/page`,
  // 查询此商户下当前信息下订单列表(服务费和税金)
  taxOrderList: `${apiHost}/bpo-web/natural/h5/queryAll/page`,
  // 查询当前待支付订单的税金税费明细
  taxOrderDetail: `${apiHost}/bpo-web/natural/h5/query/taxDetail`,
  // 拉起h5支付链接去支付
  taxGetPayUrl: `${apiHost}/bpo-web/natural/h5/get/payUrl`,
  // 服务费支付 统一下单
  servicePay: `${apiHost}/bpo-web/natural/h5/unifiedOrder`,
  // H5 微信支付结果校验
  H5PayResult: `${apiHost}/bpo-web/natural/tax/queryById/`,

  // 委托代征-连续劳务协议
  // 获取基础信息
  companyProtocolInfo: `${apiHost}/bpo-web/companyProtocol/info`,
  // 生成商户协议
  companyProtocolAddSign: `${apiHost}/bpo-web/companyProtocol/addSign`,

  // web平台查询实名信息
  checkAuth: `${apiHost}/bpo-web/natural/user/checkAuth`,

  // 海南活体认证工具
  liveUrl: `${apiHost}/bpo-web/userFace/liveUrl`,
  liveResult: `${apiHost}/bpo-web/userFace/liveResult`,

  // 人脸认证-获取人脸认证地址
  faceAuthUrl: `${apiHost}/bpo-web/apiUserFace/faceAuthUrl`,
  // 人脸认证-获取人脸认证结果
  faceAuthResult: `${apiHost}/bpo-web/apiUserFace/faceAuthResult`,
  // 扫码接单页面获取活体认证地址
  qrCodeApplyLiveUrl: `${apiHost}/bpo-web/userFace/qrCodeApplyLiveUrl`,

  // 获取已上传身份证图片链接
  photoInfo: `${apiHost}/bpo-web/natural/user/photoInfo`,

  /* 第三方服务接单 */
  // 实名认证信息提交
  thirdApplyH5: `${apiHost}/bpo-web/uc/user/third/thirdApplyH5`,
  // 获取人脸认证结果
  thirdFaceAuthResult: `${apiHost}/bpo-web/thrid/sign/faceAuthResult`,

  // 任务大厅列表接口
  taskPageList: `${apiHost}/bpo-web/platform/task/platformTasks`,

  // 验证用户在平台下是否已完成活体 入参(idNo, taskNo)
  qrCodeFaceLiveStatus: `${apiHost}/bpo-web/userFace/qrCodeFaceLiveStatus`,

  // 任务大厅 banner 图接口, 根据路由中的交付商 ID 获取对应的 banner 图
  taskPageBanner: `${apiHost}/bpo-web/platform/task/platformInfo/`,

  /*河北自然人代开*/
  // 用户登陆检查流程
  HBloginCheck: `${apiHost}/bpo-web/natural/hbuser/loginCheck`,
  // 用户注册_发送验证码
  HBregisterCode: `${apiHost}/bpo-web/natural/hbuser/registerCode`,
  // 用户注册
  HBregister: `${apiHost}/bpo-web/natural/hbuser/register`,
  // 用户登陆_发送验证码
  HBloginCode: `${apiHost}/bpo-web/natural/hbuser/loginCode`,
  // 用户登陆
  HBlogin: `${apiHost}/bpo-web/natural/hbuser/login`,
  // 获取认证参数(刷脸)
  HBqueryAuthParam: `${apiHost}/bpo-web/natural/hbuser/queryAuthParam`,
  // 获取待申请开票数据
  HBqueryTodoInvoiceList: `${apiHost}/bpo-web/natural/hbuser/queryTodoInvoiceList`,
  // 提交待申请开票数据
  HBsubmitInvoiceList: `${apiHost}/bpo-web/natural/hbuser/submitInvoiceList`,
  // 重置密码发送验证码
  HBreSetPasswordCode: `${apiHost}/bpo-web/natural/hbuser/reSetPasswordCode`,
  // 重置密码
  HBreSetPassword: `${apiHost}/bpo-web/natural/hbuser/reSetPassword`,
  // 签约合规告知确认函
  HBconfirmLetter: `${apiHost}/bpo-web/natural/hbuser/confirmLetter`,
  // 自然人身份查询
  HBnaturalPersonInfo: `${apiHost}/bpo-web/natural/hbuser/naturalPersonInfo`,
  // 同意弹窗
  HBagreeUp: `${apiHost}/bpo-web/natural/hbuser/agreeUp`,
  // 注册报错上报
  HBsaveFailUser: `${apiHost}/bpo-web/natural/hbuser/saveFailUser`,
  // 获取系统代开数据
  HBqueryInvoiceList: `${apiHost}/bpo-web/natural/hbuser/queryInvoiceList`,

  /* 单独的登录/注册/重置密码 不关联业务 */
  HBloginCheckOnly: `${apiHost}/bpo-web/natural/hbuser/loginCheckOnly`,
  HBloginCodeOnly: `${apiHost}/bpo-web/natural/hbuser/loginCodeOnly`,
  HBloginOnly: `${apiHost}/bpo-web/natural/hbuser/loginOnly`,
  HBregisterCodeOnly: `${apiHost}/bpo-web/natural/hbuser/registerCodeOnly`,
  HBregisterOnly: `${apiHost}/bpo-web/natural/hbuser/registerOnly`,
  HBreSetPasswordCodeOnly: `${apiHost}/bpo-web/natural/hbuser/reSetPasswordCodeOnly`,
  HBreSetPasswordOnly: `${apiHost}/bpo-web/natural/hbuser/reSetPasswordOnly`,
  // 补身份证照片
  HBsaveIdCardUrl: `${apiHost}/bpo-web/natural/hbuser/saveIdCardUrl`,

  /* 三方税地 万事云*/
  // 获取签约地址
  WSYscanApplyH5: `${apiHost}/bpo-web/thrid/sign/scanApplyH5`,
  // 感恩科技获取签约地址
  ganenSignUrl: `${apiHost}/bpo-web/thrid/sign/ganenSignUrl`,


  /* 湖北自然人代开 恒昌认证  */
  //  获取关联企业
  Hu_companyInfos: `${apiHost}/bpo-web/hc/companyUser/companyInfos`,
  // 个人要素认证
  HuB_userAuth: `${apiHost}/bpo-web/hc/companyUser/userAuth`,
  // 获取活体认证地址
  HuB_liveUrl: `${apiHost}/bpo-web/hc/companyUser/liveUrl`,
  // 获取活体认证结果
  HuB_liveResult: `${apiHost}/bpo-web/hc/companyUser/liveResult`,
  // 签约告知函
  HuB_signInform: `${apiHost}/bpo-web/hc/companyUser/signInform`,
  // 签约委托书列表
  HuB_signLetterList: `${apiHost}/bpo-web/hc/companyUser/letterList`,
  // 签约委托书
  HuB_signLetter: `${apiHost}/bpo-web/hc/companyUser/signLetter`,
  // 签约协议
  HuB_signProtocol: `${apiHost}/bpo-web/hc/companyUser/signProtocol`,
  // 获取协议列表
  HuB_settleQueryOne: `${apiHost}/bpo-web/hc/companyUserSettle/queryOne`,
  // 获取关联企业
  HuB_settleQueryAll: `${apiHost}/bpo-web/hc/companyUserSettle/queryAll`,
  // 获取详情
  HuB_settleInfo: `${apiHost}/bpo-web/hc/companyUserSettle/queryDetail`,
  // 签约协议
  HuB_signSettle: `${apiHost}/bpo-web/hc/companyUserSettle/signSettle`,
  // 是否有结算单签约
  HuB_settleCheckDate: `${apiHost}/bpo-web/hc/companyUserSettle/checkDate`,
  // 查询未签署记录
  HuB_queryNext: `${apiHost}/bpo-web/hc/companyUser/queryNext`,


  /* 个人上传交付物 20260805*/ 
  // 查询商户信息列表
  UD_queryMerchantNames: `${apiHost}/bpo-web/trade/userDeliverInfo/queryMerchantNames`,
  // 交易订单分页查询
  UD_queryTradePage: `${apiHost}/bpo-web/trade/userDeliverInfo/queryTradePage`,
  // 查询交付物信息
  UD_queryDeliverInfo: `${apiHost}/bpo-web/trade/userDeliverInfo/queryDeliverInfo`,
  // 上传交付物
  UD_uploadDeliverInfo: `${apiHost}/bpo-web/trade/userDeliverInfo/uploadDeliverInfo`,
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/utils/config.js